function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#009D85",
  d: "M8.362 11.84c-.213.213-.51.213-.724 0L3.385 7.588c-.213-.213-.213-.553 0-.723l.85-.85c.17-.214.511-.214.724 0l1.999 2.168V.51c0-.297.255-.51.51-.51H8.49c.298 0 .51.213.51.51v7.672l2.042-2.169c.213-.213.553-.213.723 0l.851.85c.213.171.213.511 0 .724L8.362 11.84zM15.533 13.96c.258 0 .467.209.467.467v1.106c0 .258-.209.467-.467.467H.467C.209 16 0 15.791 0 15.533v-1.106c0-.258.209-.467.467-.467h15.066z"
});

var _ref3 = React.createElement("path", {
  fill: "#009D85",
  d: "M15.533 10c.258 0 .467.209.467.467v5.066c0 .258-.209.467-.467.467h-1.106c-.258 0-.467-.209-.467-.467v-5.066c0-.258.209-.467.467-.467h1.106zM1.533 10c.258 0 .467.209.467.467v5.066c0 .258-.209.467-.467.467H.427c-.258 0-.467-.209-.467-.467v-5.066c0-.258.209-.467.467-.467h1.106z"
});

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.4905ebe3.svg";
export { ForwardRef as ReactComponent };